import { Suggestions } from 'types/suggestions';

export const getSearchListboxExpanded = (expanded: boolean, suggestions: Suggestions | null) =>
  Boolean(
    expanded && suggestions && (suggestions.newSuggestions.length > 0 || suggestions.categories.length > 0),
  );
